import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateDataByLanguage',
  pure:false
})
export class TranslateDataByLanguagePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: { en: string; fr: string }): string {
    const currentLang = this.translateService.currentLang;
    return value[currentLang];
  }

}
